import React from 'react';
import { useEffect } from 'react';
import { useNavigate  } from 'react-router-dom';
import Video from "../Assets/Videos/splash.mp4";


export default function Splash(props) {
    const navigate = useNavigate();

    useEffect(() => {
        const timeoutId = setTimeout(() => {
             navigate('/home');
        }, 6000);
        return () => {
            clearTimeout(timeoutId);
        };
    }, [navigate]);

    return (
        <React.Fragment>
            <section className="container-fluid splash max-w-lg" >

                <div className="row">
                    <div className="col-12  video-player-wrapper m-2">
                        <video className="video-player max-w-lg" playsInline="playsinline" muted={true} loop autoPlay={true} >
                            <source src={Video} type="video/mp4" />
                        </video>
                    </div>

                </div>
            </section>
        </React.Fragment>
    );
}
